




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
    getAdminUsertokens, 
    patchAdminUserTokenRegenerate, 
    postAdminUserTokenGenerate, 
    patchAdminUserTokenUnactive,
    patchAdminUserTokenReactive,
} from '@/api/api';
import User from '@/models/User';
import UserToken from '@/models/UserToken';
import UserTokenIpsAdminForm from '@/components//UserTokenIpsAdminForm.vue';
@Component({
    components: {
        UserTokenIpsAdminForm,
    },
    filters: {},
})
export default class UserUserTokenList extends Vue{
    userTokens: any = [];
    @Prop() user!: User;

    async created(){
        const dataUserTokens = await getAdminUsertokens(this.user.id);
        this.userTokens = dataUserTokens.data;
    }

    reactiveDialog(userToken: UserToken) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Réactivation Accès API",
            text: "Etes vous sur de vouloir Réactivé les accès API ?",
            accept: () => this.reactiveToken(userToken.id),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async reactiveToken(id: any) {
        const { data } = await patchAdminUserTokenReactive(id);
        let ArrayUserTokens = this.userTokens;
        this.userTokens.forEach(function(value: any, key: any){
            if(data.id === value.id){
                ArrayUserTokens[key] = data;
            }
        });
        this.userTokens = ArrayUserTokens;
        this.$forceUpdate();
    }

    unactiveDialog(userToken: UserToken) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Désactivation Accès API",
            text: "Etes vous sur de vouloir desactivé les accès API ?",
            accept: () => this.unactiveToken(userToken.id),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async unactiveToken(id: any) {
        const { data } = await patchAdminUserTokenUnactive(id);
        let ArrayUserTokens = this.userTokens;
        this.userTokens.forEach(function(value: any, key: any){
            if(data.id === value.id){
                ArrayUserTokens[key] = data;
            }
        });
        this.userTokens = ArrayUserTokens;
        this.$forceUpdate();
    }

    refreshDialog(userToken: UserToken) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: "Regnération Accès API",
            text: "Etes vous sur de vouloir regénéré les acces API ? Cette Action est irréversible",
            accept: () => this.refreshToken(userToken.id),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async refreshToken (id: any) {
        const { data } = await patchAdminUserTokenRegenerate(id);
        let ArrayUserTokens = this.userTokens;
        this.userTokens.forEach(function(value: any, key: any){
            if(data.id === value.id){
                ArrayUserTokens[key] = data;
            }
        });
        this.userTokens = ArrayUserTokens;
        this.$forceUpdate();
    }

    async createUserToken(user: User) {
        const {data} = await postAdminUserTokenGenerate(user);
        this.userTokens.push(data);
        this.$forceUpdate();
    }
}
